import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';

const state = () => ({
  snapshots: {},
});

const mutations = {
  addSnapshot(state: any, data: any) {
    state.snapshots[data.id] = data.data;
    state.snapshots = { ...state.snapshots };
  },
  updateSnapshot(state: any, data: any) {
    state.snapshots[data.id] = { ...state.snapshots[data.id], ...data.data };
    state.snapshots = { ...state.snapshots };
  },
  removeSnap(state: any, virtualMachineId: any) {
    delete state.snapshots[virtualMachineId];
    state.snapshots = { ...state.snapshots };
  },
};

const actions = {
  getSnapshot({ commit, state, rootState }: any, virtualMachineId: number) {
    return new Promise(resolve => {
      if (state.snapshots[virtualMachineId]) {
        resolve(state.snapshots[virtualMachineId]);
        return;
      }
      virtualMachineDetailsService
        .getSnapshot(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId, virtualMachineId)
        .then((data: any) => {
          commit('addSnapshot', { id: virtualMachineId, data: data });
          resolve(data);
        });
    });
  },
  getSnapshotForced({ commit, state, rootState }: any, virtualMachineId: number) {
    return virtualMachineDetailsService
      .getSnapshot(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId, virtualMachineId)
      .then((data: any) => {
        commit('addSnapshot', { id: virtualMachineId, data: data });
      });
  },
};

const getters = {
  getSnapshotByVirtualMachineId: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.snapshots[id] || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
